import { DemoStage } from './components/DemoStage'
import { deriveVals } from './demo/derive'
import { useDemo } from './demo/useDemo'

export default function App() {
  const { state, api } = useDemo()
  const vals = deriveVals(state, api)

  return (
    <DemoStage v={vals} architecture={state.arch} onArchitectureChange={api.setArchitecture} />
  )
}
